export const ASSOCIATED_PRODUCT_TYPES = {
  complementaryProducts: 'Produtos que você vai precisar',
  accessoryProducts: 'Aproveite e leve junto'
}
